import styled, { css } from 'styled-components/macro';
import { darken } from 'polished';

import modularScale from 'styles/helpers/modular-scale';

import H1 from 'components/elements/h1';
import { Main } from 'components/Glossary/Glossary.style';

export const Button = styled('button')<{ color: string }>`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme, color }): string => (color ? color : theme.AccentGreen)};
  cursor: pointer;

  &:hover {
    color: ${({ theme, color }): string =>
      darken(0.1, color ? color : theme.AccentGreen)};
  }

  &:focus:not(:active) {
    border: 1px dotted ${({ theme }): string => theme.NightBlue};
  }
  @media screen and (min-width: 40em) {
    margin-left: 1rem;
    padding: 0.6em 0;
  }
`;

export const H2 = styled(H1)<{ bottomMargin: string }>`
  margin: ${({ bottomMargin }): string => `0 0.3em ${bottomMargin} 0`};
  font-size: 1.125em;
  font-weight: 600;
  color: ${({ theme }): string => theme.NightBlue};
`;

export const LoadingBarWrapper = styled('div')`
  position: absolute;
  left: 0;
  top: -2px;
  width: 100%;
  height: 2px;
`;

export const ReadMoreButton = styled('button')<any>`
  color: ${({ theme }): string => theme.AccentGreen};
  padding: 0;
  margin-top: 1em;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledLink = styled('a')`
  display: inline-block;
  color: ${({ theme }): string => theme.AccentGreen};
  text-decoration-skip-ink: auto;
  cursor: pointer;

  &:hover {
    color: ${({ theme }): string => darken(0.1, theme.AccentGreen)};
  }

  &:focus:not(:active) {
    border: 1px dotted ${({ theme }): string => theme.NightBlue};
  }
`;

export const StyledMain = styled(Main)<any>`
  hr {
    display: none;

    /** Hide all siblings after the <hr /> when the user didn't yet expand the content. */
    ~ * {
      ${({ expanded }): any =>
        !expanded &&
        css`
          display: none;
        `};
    }
  }
  p {
    margin-top: 1.5em;
    font-size: 15px;
  }
`;

export const SquareButton = styled('button')`
  padding: 0.3em 1.8em;
  appearance: none;
  background-color: ${({ theme }) => theme.AccentGreen};
  color: ${({ theme }) => theme.White};
  font-weight: 600;
  font-size: ${modularScale(-1)};
  border-radius: 3px;
`;

export const TextArea = styled('textarea')<any>`
  padding: 1.25em;
  width: 100%;
  border: 1px solid #c7c7c7;
  font: inherit;
  font-size: 15px;
`;
